import * as actionTypes from "./actionTypes";

import {
  CountyInfo,
  ReportTypesInfo
} from "../business-objects/common";

interface IKeywordState {
  keyword: any;
  counties: CountyInfo[];
  reportTypes: ReportTypesInfo[];
}

const initialKeywordState = {
  keyword: "",
  counties: [],
  reportTypes: []
};

export default (state: IKeywordState = initialKeywordState, action: any) => {
  let _state = { ...state };
  switch (action.type) {
    case actionTypes.LOAD_KEYWORD_INTO_STORE:
      _state = {
        ...state,
        keyword: action.value
      };
      return _state;
    case actionTypes.LOAD_COUNTIES_INTO_STORE:
      _state = {
        ...state,
        counties: action.value
      };
      return _state;
    case actionTypes.LOAD_REPORT_TYPES_INTO_STORE:
      _state = {
        ...state,
        reportTypes: action.value
      };
      return _state;
    default:
      return _state;
  }
};
